import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const APP_TITLE = "Workspaces";

const titleOverrides = {
  aob: "AOB",
  mips: "MIPs",
};

const toTitleCase = (value) =>
  value
    .replace(/[-_]+/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

const getPageTitle = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);
  const pageSegment = segments[1] || segments[0];

  if (!pageSegment) {
    return APP_TITLE;
  }

  const normalizedPageSegment = pageSegment.toLowerCase();
  const pageTitle = titleOverrides[normalizedPageSegment] || toTitleCase(pageSegment);

  return `${pageTitle}- ${APP_TITLE}`;
};

const DocumentTitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location.pathname]);

  return null;
};

export default DocumentTitleUpdater;
